<template>
  <div class="container-fluid full-height">
    <div class="row justify-content-center align-items-center full-height">
      <div class="col-10 col-sm-8 col-md-6 col-xl-6">
        <card>
          <h2 slot="header" class="card-title text-center">
            <strong>Forget Password</strong>
          </h2>
          <hr />
          <form @submit.prevent="login">
            <div class="row justify-content-md-center">
              <div class="col-11" style="display: none"></div>
              <div class="col-11">
                <fg-input type="email"
                          v-model="user.email.value"
                          label="E-mail"
                          placeholder="Enter E-mail"
                          data-vv-value-path="user.email.value"
                          v-validate="user.email.rule"
                          data-vv-name="email"
                          cus-name="email"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-11">
                <button type="submit"
                        :disabled="errors.any() || !isComplete"
                        class="btn btn-primary btn-fill btn-block">
                  Send
                </button>
                <div class="my-2">
                  <router-link to="/login">back to login</router-link>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card,
    },
    data () {
    return {
      user: {
        email: {
          value:'',
          rule:{ required: true, email: true}
        }
      }
    }
  },
  methods: {
    login () {
      console.log("this.$validator : ", this.$validator);
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          alert('From Submitted!');
        }

        alert('Correct them errors!');
      })
    }
  },
  computed: {
    isComplete () {
      return this.user.email.value;
    }
  }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/ForgetPassword.vue